const ObjectUtils = {
  clone(object) {
    return JSON.parse(JSON.stringify(object));
  },
  isEmpty(object) {
    const keys = Object.keys(object);
    return keys && keys.length === 0;
  },
  trimObjectFields(obj, fieldsToTrim) {
    const newObj = { ...obj };
    if (fieldsToTrim.length > 0) {
      fieldsToTrim.forEach((field) => {
        if (field in obj && typeof obj[field] === "string") {
          newObj[field] = obj[field].trim();
        }
      });
    }
    return newObj;
  }
};
export default ObjectUtils;
